import { useCallback } from 'react';

export function usePaymentFields() {
  const setupFieldValidation = useCallback((PaymentSession, onValidityChange) => {
    const fields = [
      "card.number",
      "card.securityCode",
      "card.expiryMonth",
      "card.expiryYear",
      "card.nameOnCard"
    ];

    // Validate on blur
    PaymentSession.onBlur(fields, (selector) => {
      PaymentSession.validate('card', (result) => {
        const field = selector.replace('card.', '');
        const element = document.querySelector(`#${field}`);
        if (!element) return;

        if (result.card[field].isValid) {
          element.style.borderColor = "#22c55e";
        } else {
          element.style.borderColor = "#ef4444";
        }
      });
    });

    // Real-time validation
    PaymentSession.onValidityChange(fields, (selector, result) => {
      const element = document.querySelector(selector.replace('card.', '#'));
      if (!element) return;

      if (result.isValid) {
        element.style.borderColor = "#22c55e";
      } else if (result.isIncomplete) {
        element.style.borderColor = "#9ca3af";
      } else {
        element.style.borderColor = "#ef4444";
      }

      if (onValidityChange) {
        onValidityChange(selector, result);
      }
    });
  }, []);

  return {
    setupFieldValidation
  };
}